import React from 'react'

function Footer() {
  return (
    <div className='footer'>
        <p>Ana Sobrino ☺︎</p>
    </div>
  )
}

export default Footer